import ApiClient from '@/libs/http-client'

const TeamService = {
    endpoints(route, param) {
        const url = {
            getTeams: '/api/teams',
            updateTeam: `/api/users/${param}`,
            newTeam: '/api/teams',
            reviewStatus: '/api/assessments/status',
            getQuestions: '/api/assessments/questions',
            selfAssessmentUrl:'/api/assessments/answers/insert'
        }
        return url[route]
    },
    get(url, param = {}) {
        return ApiClient.get(this.endpoints(url, param));
    },
    getData(url, param = {}, data) {
    return ApiClient.get(this.endpoints(url, param), data);
  },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config);
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config);
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config);
    },
    postFile(url, params = {}, data, config = {}) {
        config = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "multipart/form-data",
            },
            ...config
        }
        return ApiClient.post(this.endpoints(url, params), data, config);
    },



  setReviewStatus( data, config) {
    return ApiClient.put(`/api/assessments/status`, data, config)
  },

  selfAssessment( data, config) {
    return ApiClient.post(`/api/assessments/answers/insert`, data, config)
  },

  resetAnswers(user_id, author_id, config) {
    return ApiClient.delete(`/api/assessments/answers?user_id=${user_id}&author_id=${author_id}`, config)
  },

  getUserAnswers(user_id, author_id, config) {
    return ApiClient.get(`/api/assessments/answers?user_id=${user_id}&author_id=${author_id}`, config)
  },

    getUserAnswersCycle(user_id, author_id, cycle_id, config) {
        return ApiClient.get(`/api/assessments/answers?user_id=${user_id}&author_id=${author_id}&cycle_id=${cycle_id}`, config)
    },

    getCycles(config) {
        return ApiClient.get('/api/assessments/cycles', config)
    },

  getUserAnswersByName(user_name, author_name, config) {
    return ApiClient.get(`/api/assessments/answers?user_name=${user_name}&author_name=${author_name}`, config)
  },

    getUserAnswersByNameCycle(user_name, author_name, cycle_id, config) {
        return ApiClient.get(`/api/assessments/answers?user_name=${user_name}&author_name=${author_name}&cycle_id=${cycle_id}`, config)
    },

  getGraph(user_name, config) {
    return ApiClient.get(`/api/assessments/answers/graph?user_name=${user_name}`, config)
  },

    getGraphCycle(user_name, cycle_id, config) {
        return ApiClient.get(`/api/assessments/answers/graph?user_name=${user_name}&cycle_id=${cycle_id}`, config)
    },

  changeTeam(id, data, config) {
    return ApiClient.put(`/api/teams/${id}`, data, config)
  },


  deleteTeam(id, config) {
    return ApiClient.delete(`/api/teams/${id}`, config)
  },

  createTeam( data, config) {
    return ApiClient.post(`/api/teams/`, data, config)
  },

  getMyTeams(id, config) {
    return ApiClient.get(`/api/teams/?user_id=${id}`, config)
  },

  getMyResults(id, config) {
    return ApiClient.get(`/api/assessments/answers?user_id=${id}`, config)
  },

    getMyResultsCycle(user_id, cycle_id, config) {
        return ApiClient.get(`/api/assessments/answers?user_id=${user_id}&cycle_id=${cycle_id}`, config)
    },

  getMateResults(name, author_id, config) {
    return ApiClient.get(`/api/assessments/answers?user_name=${name}`, config)
  },

    getMateResultsCycle(name, cycle_id, config) {
        return ApiClient.get(`/api/assessments/answers?user_name=${name}&cycle_id=${cycle_id}`, config)
    },

  getMateWhoVoted(name, config) {
    return ApiClient.get(`/api/assessments/answers/users?user_name=${name}`, config)
  },

    getMateWhoVotedCycle(name, id, config) {
        return ApiClient.get(`/api/assessments/answers/users?user_name=${name}&cycle_id=${id}`, config)
    },

}

export default TeamService
